import { type AcpSelectConfigOption, flattenConfigOptions } from '@/lib/desktop-config-options';
import type { KeyboardShortcut } from '@/lib/platform';

/** Cycles the conversation's permissions from the composer (⇧Tab). */
export const PERMISSIONS_SHORTCUT: KeyboardShortcut = { key: 'Tab', shift: true };

/** The conversation's permissions setting (Ask, Auto edits, Full access), if the agent has it. */
export function permissionOption(
  options: readonly AcpSelectConfigOption[],
): AcpSelectConfigOption | undefined {
  return options.find((option) => option.category === 'permission');
}

/** The name of the permissions in effect ("Auto"). */
export function permissionName(option: AcpSelectConfigOption): string {
  return (
    flattenConfigOptions(option).find((choice) => choice.value === option.currentValue)?.name ??
    option.name
  );
}

/** The permissions after the current ones, wrapping around. */
export function nextPermissionValue(option: AcpSelectConfigOption): string | null {
  const choices = flattenConfigOptions(option);
  if (choices.length < 2) return null;
  const index = choices.findIndex((choice) => choice.value === option.currentValue);
  return choices[(index + 1) % choices.length]?.value ?? null;
}
